import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/features/auth/AuthProvider";
import { queryClient } from "@/lib/queryClient";

const toastOptions = {
  duration: 4000,
  style: {
    background: "rgba(255, 255, 255, 0.95)",
    color: "#1e293b",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "12px",
    backdropFilter: "blur(10px)",
    boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
  },
  success: {
    iconTheme: { primary: "#10b981", secondary: "white" },
  },
  error: {
    iconTheme: { primary: "#ef4444", secondary: "white" },
  },
};

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system" storageKey="trading-platform-theme">
        <AuthProvider>
          {children}
          <Toaster position="top-right" toastOptions={toastOptions} />
        </AuthProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}
